export interface SFActiveSchema {
    /**
     * 元素组件大小
     * @default 'large'
     */
    size?: 'default' | 'large' | 'small';
}
